import styled from 'styled-components';
import { Link as LinkS } from 'react-scroll';

/* Shared sticky category/type navigation used by both the guest market list
   (GMarketAltList) and the admin market list (MarketList), so logged-in and
   logged-out views behave identically. */

export const GNav = styled.nav`
  background: #e9e9ec;
  height: 66px;
  margin-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  position: sticky;
  top: 128px; /* navbar (64px) + search bar (~64px) */
  z-index: 10;

  @media screen and (min-width: 900px) {
    top: 148px; /* navbar (80px) + search bar (~68px) */
    height: 80px;
    margin-top: 50px;
  }
`;

export const GNavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 80px;
  z-index: 1;
  width: 100%;
  padding: 0 24px;
  max-width: 1300px;
`;

export const GbarLink = styled(LinkS)`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  text-decoration: none;
  font-weight: 400;
  list-style: none;
  transition: 0.2s ease-in-out;
  color: #fff;
  cursor: pointer;

  background: #01bf71;
  white-space: nowrap;
  padding: 6px 12px;
  margin: 8px 0;

  /* fluid width with a floor instead of a fixed size */
  width: auto;
  min-width: 96px;
  flex: 0 0 auto;
  font-size: 0.875rem;

  @media screen and (min-width: 480px) {
    min-width: 120px;
    font-size: 1rem;
    padding: 6px 16px;
  }

  &:hover {
    color: #01bf71;
    transition: 0.2s ease-in-out;
  }
`;

/* responsive horizontal scroller for the market/type nav */
export const TypeScroller = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  max-width: 1200px;
  max-height: 100px;

  /* center when items fit, fall back to scroll (no clipping) when they don't */
  justify-content: safe center;

  /* mobile-friendly scrolling */
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;    /* momentum on iOS */
  scroll-snap-type: x proximity;         /* items click into place */
  overscroll-behavior-x: contain;        /* don't trigger page back-swipe */
  scrollbar-width: none;                 /* Firefox: hide scrollbar */

  &::-webkit-scrollbar {                 /* Chrome/Safari: hide scrollbar */
    display: none;
  }
  & > * {
    scroll-snap-align: start;
  }

  /* edge fade hints that the row scrolls */
  -webkit-mask-image: linear-gradient(
    to right, transparent, #000 24px, #000 calc(100% - 24px), transparent
  );
  mask-image: linear-gradient(
    to right, transparent, #000 24px, #000 calc(100% - 24px), transparent
  );
`;
